angular.module('filters.humanize', [])
  .filter('humanize', function () {
    return function(input) {
      return devex.util.humanize(input);
    };
  })

  .filter('humanizeList', function () {
    return function(input, options) {
      return devex.util.humanizeList(input, options);
    };
  })

  .filter('dehumanize', function () {
    return function(input) {
      return devex.util.dehumanize(input);
    };
  });
